import { tsUtils } from '@neo-one/ts-utils';
import ts from 'typescript';
import { NodeCompiler } from '../NodeCompiler';
export class ExpressionStatementCompiler extends NodeCompiler {
    constructor() {
        super(...arguments);
        this.kind = ts.SyntaxKind.ExpressionStatement;
    }
    visitNode(sb, node, options) {
        sb.visit(tsUtils.expression.getExpression(node), sb.noPushValueOptions(options));
    }
}

//# sourceMappingURL=ExpressionStatementCompiler.js.map
